import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelDownloadButton = (props) => {
  const handleDownload = () => {
    let data=props.data
    if(!data[0])
    data=[{"Note":"No Results Found"}]
    for(let it of data){
      if(it.TaskDescription){
        if(it.TaskDescription.length>=32767){
          it.TaskDescription=it.TaskDescription.slice(0,32763)
          it.TaskDescription=it.TaskDescription+"..."
        }
        if(it.TaskName.length>=32767){
          it.TaskName=it.TaskName.slice(0,32763)
          it.TaskName=it.TaskName+"..."
        }
      }
    }
    const dataArray=data.map(obj=>Object.values(obj))
    // console.log(dataArray)
  // Insert column headers as the first row of the 2D array
  const headers = Object.keys(data[0]);
  dataArray.unshift(headers);
    // Create a new workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(dataArray);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, `${props.vertical.trim()!="Select"?props.vertical:props.search}`);

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });

    // Convert the Excel buffer to a Blob
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Save the Blob as a file with the desired filename
    saveAs(blob, `${props.vertical.trim()!="Select"?props.search+'_'+props.vertical:props.search}_search.xlsx`);
  };

  return (
    <button onClick={handleDownload} className='absolute right-5 flex flex-row gap-2 border-2 border-gray-500 p-1 px-2 rounded-md font-normal text-white bg-gray-800'>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 z-10">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
</svg>
    </button>
  );
};

export default ExcelDownloadButton;
